<p>
    <mat-toolbar>
      <span>{{title}}</span>
      <span class="spacer"></span>
      <app-button
        text="{{buttonText}}"
        (click)="onAction($event)"
      ></app-button>
    </mat-toolbar>
</p>
